import { JimdoApp } from '../../components';

export enum LoggerTypes {
  WARN,
  LOG,
  ERROR,
  INFO,
  DEBUG,
}

export const logger = async (type: LoggerTypes, message: any, jimdoApp?: JimdoApp, ...args: any[]) => {
  const { reportException, reportWarning } = await import('@jimdo/monitoring');
  const env = process.env.NODE_ENV || '';
  const prefix = '[Experiment] ';
  if (['development'].includes(env)) {
    switch (type) {
      case LoggerTypes.WARN:
        console.warn(prefix, message);
        return;

      case LoggerTypes.LOG:
        console.log(prefix, message);
        return;

      case LoggerTypes.ERROR:
        console.error(prefix, message);
        return;

      case LoggerTypes.INFO:
        console.info(prefix, message);
        return;

      case LoggerTypes.DEBUG:
        console.debug(prefix, message);
        return;

      default:
        return;
    }
  }

  // staging or prod
  if (typeof document !== 'undefined') {
    if (type === LoggerTypes.ERROR) {
      reportException(message, {
        content: 'Logging',
        framework: 'growth-tools',
        jimdoApp,
        ...args,
      });
    } else if (type === LoggerTypes.WARN) {
      reportWarning(message, {
        content: 'Logging',
        framework: 'growth-tools',
        jimdoApp,
        ...args,
      });
    }
  }
};
